import appleTouch from './apple-touch-icon.png';
import size16 from './favicon-16x16.png';
import size32 from './favicon-32x32.png';
import icoFormat from './favicon.ico';
import safariPinnedTab from './safari-pinned-tab.svg';

export {
    appleTouch, size16, size32, icoFormat, safariPinnedTab
};




// WEBPACK FOOTER //
// ./src/favicons/index.js